import { Text, type TextStyle } from 'react-native'

import { convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const baseFontWeight = String(theme.fontWeightBold) as TextStyle['fontWeight']

  return {
    base: {
      fontFamily: 'RDModern-Bold',
      fontWeight: baseFontWeight,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      variant: {
        'brand-primary': {
          color: theme.colorTextNeutralInverse,
        },
        'neutral-secondary': {
          color: theme.colorTextNeutralDefault,
        },
        'neutral-tertiary': {
          color: theme.colorTextNeutralDefault,
        },
      },
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {
          fontSize: theme.fontSizeThreeandhalfpulse,
        },
        lg: {
          fontSize: theme.fontSizeThreeandhalfpulse,
        },
        xl: {
          fontSize: theme.fontSizeThreeandhalfpulse,
        },
      },
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
